module.exports = __webpack_public_path__ + "img/Game_target_Z-23.03e167b6.png";